import React, { useState } from 'react';
import {
  Col, Row, Spinner,
} from 'react-bootstrap';
import { useSelector } from 'react-redux';

import MLTSelector from 'components/Flux/Automatic/MLTSelector';
import UnicenarioTable from 'components/Flux/Unicenario/Table';
import RevisionSubTableModal from 'components/Flux/Revision/SubTableModal';
import RevisionSelector from 'components/Flux/Automatic/RevisionSelector';
import Snackbar from 'components/DesignSystem/Snackbar';
import {
  selectFluxAutomaticControlPanelMltOption,
  selectFluxAutomaticControlPanelSelectedRevision,
  selectFluxAutomaticControlPanelUnicenarioScenario,
} from 'redux/reducers/fluxAutomaticControlPanelReducer';
import useFluxAutomaticZipDownload from 'utils/hooks/flux/automatic/useFluxAutomaticZipDownload';
import useUnicenarioData from 'utils/hooks/flux/automatic/useUnicenarioData';
import useUnicenarioScenarios from 'utils/hooks/flux/automatic/useUnicenarioScenarios';
import usePeriodControls from 'hooks/Flux/Automatic/Revision/usePeriodControls';
import { cssVar } from 'constants/theme';

export default function UnicenarioDesktop() {
  const unidade = useSelector(selectFluxAutomaticControlPanelMltOption);
  const unicenarioScenario = useSelector(selectFluxAutomaticControlPanelUnicenarioScenario);
  const review = useSelector(selectFluxAutomaticControlPanelSelectedRevision);
  const {
    isFetching, hasData, unicenarioSections, colLabels,
  } = useUnicenarioData();

  const [isOpen, setIsOpen] = useState(false);
  const [period, setPeriod] = useState('');
  const {
    data,
    isFetching: isFetchingScenarios,
    errorMessage,
  } = useUnicenarioScenarios(period);
  const {
    toFirst,
    toPrevious,
    toNext,
    toLast,
    isFirstPeriod,
    isLastPeriod,
  } = usePeriodControls(period, colLabels, setPeriod);

  const popDataModal = (chosenPeriod: string) => {
    setIsOpen(true);
    setPeriod(chosenPeriod);
  };

  const { DownloadZipButton, DownloadConfirmationDialog } = useFluxAutomaticZipDownload({
    models: unicenarioScenario ? [unicenarioScenario] : [],
    review,
    unidade,
    type: 'unicenario',
    pastSimulationNames: [],
    spatialSubdivisionParam: {},
  });

  return (
    <>
      <RevisionSubTableModal
        isOpen={isOpen}
        period={period}
        data={data?.data}
        revision={review}
        modelName={unicenarioScenario ?? ''}
        errorMessage={errorMessage}
        onClose={() => setIsOpen(false)}
        toFirst={toFirst}
        toPrevious={toPrevious}
        toNext={toNext}
        toLast={toLast}
        isFirstPeriod={isFirstPeriod}
        isLastPeriod={isLastPeriod}
        isFetchingScenarios={isFetchingScenarios}
      />
      <div className="pt-4 px-5">
        <DownloadConfirmationDialog />
        <Row className="px-3 pb-2" style={{ backgroundColor: cssVar('bg-subtle') }}>
          <Col>
            <MLTSelector disabled />
          </Col>
          <Col>
            <RevisionSelector />
          </Col>
          <Col xs={1}>
            <DownloadZipButton />
          </Col>
        </Row>
        <div className="overflow-auto" style={{ height: 'calc(90vh - 80px)' }}>
          {isFetching && <div className="text-center py-4"><Spinner /></div>}
          {!isFetching && !unicenarioScenario && (
            <Snackbar>
              Selecione um cenário no painel lateral para visualizar os dados.
            </Snackbar>
          )}
          {!isFetching && unicenarioScenario && !hasData && (
            <Snackbar>
              Nenhum dado para os filtros selecionados.
            </Snackbar>
          )}
          {!isFetching && unicenarioScenario && hasData && (
            <UnicenarioTable
              unicenarioSections={unicenarioSections}
              colLabels={colLabels}
              popDataModal={popDataModal}
            />
          )}
        </div>
      </div>
    </>
  );
}
